import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NoticeboardAPICall from 'NoticeboardAPICall';
import './CategoryList.css';
import config from 'config';
import ButtonLoader from 'NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'NOTICEBOARD/CommonResources/DeleteModal/DeleteModal';
import Pagination from 'react-js-pagination';
import { Close } from '@mui/icons-material';

//import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';

const apiPath = "/api/notice/category.php";
const apiPath1 = "/api/instructor/facultyRegistration.php";
const apiPath2 = "/api/admission/streamManagement.php";

function CategoryList() {

	// STATE FOR ADD CATEGORY 
	const [selectedAccessType, setSelectedAccessType] = useState('postNoticeAccess');
	const [categoryFetching, setCategoryFetching] = useState(false);
	const [categoryList, setCategoryList] = useState({});
	const [categorySequence, setCategorySequence] = useState([]);
	const [categoryCount, setCategoryCount] = useState(0);
	const [categoryModal, setCategoryModal] = useState(false);
	const [categoryName, setCategoryName] = useState('');
	const [categorySeries, setCategorySeries] = useState('');
	const [categoryDescription, setCategoryDescription] = useState('');
	const [status, setStatus] = useState('Active');
	const [categoryEditMode, setCategoryEditMode] = useState(false);
	const [categoryUniqueId, setCategoryUniqueId] = useState('');

	// STATE FOR FILTER CATEGORY
	const [selectedCategoryIds, setCategoryIds] = useState([]);
	const [selectedUserId, setUserId] = useState([]);
	const [filterTitle, setFilterTitle] = useState('');
	const [filterStatus, setFilterStatus] = useState('');

	// STATE FOR CATEGORY VALIDATION ERROR
	const [categoryNameError, setCategoryNameError] = useState('');
	const [categorySeriesError, setCategorySeriesError] = useState('');

	const [categoryDescriptionError, setCategoryDescriptionError] = useState('');
	const [categoryEnteredName, setCategoryEnteredName] = useState('');

	// STATE FOR PAGINATION 
	const [pagination, setPagination] = useState({
		offset: 0,
		limit: 10,
		activePage: 1
	});

	// STATE FOR MEMBER PAGINATION
	const [memberPagination, setMemberPagination] = useState({
		offset: 0,
		limit: 10,
		activePage: 1
	});

	// STATE FOR DELETE MODAL
	const [deleteModalDetails, setDeleteModalDetails] = useState({
		deleteModal: false,
		deleteModalText: '',
		deleteErrorVisibility: false
	});

	// STATE FOR SUCCESS MODAL
	const [successModalDetails, setSuccessModalDetails] = useState({
		successModal: false,
		successModalType: '',
		successMessage: ''
	});

	// STATE FOR TOTAL RECORD AND SEARCH EMPLOYEE
	const [totalRecord, setTotalRecord] = useState(0);
	const [searchEmployee, setSearchEmployee] = useState('');
	//const[searchCategory,setSearchCategory] = useState('');

	// STATE FOR ASSIGN ACCESS AND ADD DEPARTMENT
	const [departments, setDepartments] = useState([]);
	const [employeeList, setEmployeeList] = useState({});
	const [employeeFetching, setEmployeeFetching] = useState(false);
	const [AssignAccess, setAssignAccess] = useState(false);
	const [departmentList, setDepartmentList] = useState([]);
	const [selectedDepartmentIds, setDepartmentIds] = useState([]);
	const [selectDepartment, setSelectDepartment] = useState(false);
	const [tempAccessObject, setTempAccessObject] = useState({});
	const [accessObject, setAccessObject] = useState({});
	const [currentEmployeeId, setCurrentEmployeeId] = useState('');
	const [grantAccessWarning, setUserErrorMessage] = useState('');
	const [selectDepartmentError, setSelectDepartmentError] = useState('');

	// API CALL FOR GET CATEGORY LIST FIRST TIME
	useEffect(() => {
		getCategoryListAPICall();
		getEmployeeDetailsAPICall(searchEmployee);
		getDepartmentListAPICall();
	}, []);

	// API CALL FOR GET CATEGORY LIST
	useEffect(() => {
		getCategoryListAPICall();
		getEmployeeDetailsAPICall(searchEmployee);
	}, [pagination]);

	// HOOKS FOR GET MEMBER DETAILS API CALL
	useEffect(() => {
		getEmployeeDetailsAPICall(searchEmployee);
	}, [memberPagination]);


	// METHOD TO GET ASSIGN ACCESS API CALL
	const getEmployeeDetailsAPICall = async (employeeName) => {
		setEmployeeFetching(true);

		let formData = {
			"iid": config.institute_id,
			"type": "all",
			"page_index": memberPagination.activePage,
			"limit": memberPagination.limit,
			"status": '0',
			"role": "",
			"search": employeeName,
			"selectedStream": 0,
			"selectedDepartment": 0
		}
		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'getFacultyList',
			formData,
			apiPath1
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				getEmployeeDetailsAPICall(employeeName);
			}, 1000);
		} else {
			if (jsonResponse.APIResult.success) {
				let apiResult = jsonResponse.APIResult.data;
				setEmployeeList(apiResult);
				setTotalRecord(jsonResponse.APIResult.totalRecords);
				setEmployeeFetching(false);
			} else {
				setAssignAccess(false);
			}
		}
	}

	//METHOD TO GET DEPARTMENT LIST API CALL
	const getDepartmentListAPICall = async () => {
		let formData = {
			"iid": config.institute_id,
			"sidArray": []
		}
		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'GetInstituteStreamsObject',
			formData,
			apiPath2
		);
		if (jsonResponse.expired) {
			setTimeout(() => {
				getDepartmentListAPICall();
			}, 1000);
		} else {
			if (jsonResponse.APIResult.success) {
				let apiResult = jsonResponse.APIResult.data;
				if (Object.keys(apiResult).length > 0) {
					Object.keys(apiResult).map(departmentId => {
						apiResult[departmentId]['departmentId'] = departmentId;
					});
				}
				setDepartmentList(apiResult);
			} else {
				setAssignAccess(false);
			}
		}
	}

	// METHOD FOR ASSIGN ACCESS
	const apiCallToAssignAccess = async () => {
		let formData = {
			"iid": config.institute_id,
			"categoryId": selectedCategoryIds.toString(),
			"userIdSIDObject": accessObject,
			"added_by": config.faculty_id,
			"access_type": selectedAccessType
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'assignAccessCategory',
			formData,
			apiPath
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				apiCallToAssignAccess();
			}, 1000);
		} else {
			if (jsonResponse.APIResult.success) {
				if (jsonResponse.APIResult.status == "success") {
					let apiResult = jsonResponse.APIResult;
					setAccessObject(apiResult);
					setAssignAccess(false);
					setSuccessModalDetails({
						successModal: true,
						successModalType: "success",
						successMessage: jsonResponse.APIResult.message
					});
					getCategoryListAPICall();

				} else {
					setSuccessModalDetails({
						successModal: true,
						successModalType: "warning",
						successMessage: 'Unable to add stream access as they are already available.'
					});
				}
			} else {

				setSuccessModalDetails({
					successModal: true,
					successModalType: "error",
					successMessage: jsonResponse.APIResult.message
				});
				setAssignAccess(false);
			}
		}

	}

	// METHOD TO GET CATEGORY LIST API CALL    
	const getCategoryListAPICall = async () => {
		setCategoryFetching(true);

		let formData = {
			"iid": config.institute_id,
			"offset": pagination.offset,
			"limit": pagination.limit,
			"filterCategoryName": filterTitle,
			"filterStatus": filterStatus,
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'GetNoticeBoardCategoryList',
			formData,
			apiPath
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				getCategoryListAPICall();
			}, 1000);
		} else {
			if (jsonResponse.success) {
				let apiResult = jsonResponse.APIResult.data;
				if (Object.keys(apiResult).length > 0) {
					Object.keys(apiResult).map(categoryId => {
						apiResult[categoryId]['categoryId'] = categoryId;
					});
				}

				setCategoryList(apiResult);
				setCategorySequence(jsonResponse.APIResult.sequenceIdArray);
				setCategoryCount(jsonResponse.APIResult.category_count);
				setCategoryFetching(false);
			} else {
				setCategoryFetching(false);
				setSuccessModalDetails({
					successModal: true,
					successModalType: "error",
					successMessage: "Something went wrong while getting category list. Please try again later."
				});
			}
		}

	}

	// METHOD TO SELECT ALL CATEGORIES
	const selectAllCategories = (e) => {
		let categoryIdSet = new Set();
		if (e.target.checked) {
			Object.keys(categoryList).map(categoryId => {
				categoryIdSet.add(categoryId);
			});
		} else {
			Object.keys(categoryList).map(categoryId => {
				categoryIdSet.delete(categoryId);
			});
		}
		setCategoryIds(Array.from(categoryIdSet));
	}

	// METHOD TO SELECT SINGLE CATEGORY
	const selectSingleCategory = (categoryId) => {
		let selectedCategoryId = selectedCategoryIds;
		if (selectedCategoryId.includes(categoryId)) {
			selectedCategoryId = selectedCategoryId.filter(id => id != categoryId);
		} else {
			selectedCategoryId.push(categoryId);
		}
		setCategoryIds([...selectedCategoryId]);

	}

	// METHOD TO SELECT SINGLE USER 
	const removeSingleUser = (employeeId, categoryId, sid, accessType) => {
		getRemoveCategoryAccess(employeeId, categoryId, sid, accessType);
	}

	// METHOD TO SELECT SINGLE EMPLOYEE
	const selectSingleEmployee = (e, employeeId) => {

		let tempAccessObjects = tempAccessObject;
		let accessObjects = accessObject;

		if (e.target.checked) {
			if (tempAccessObjects[employeeId] == undefined) {
				tempAccessObjects[employeeId] = [];
				setUserErrorMessage('');
			}

			if (accessObjects[employeeId] == undefined) {
				accessObjects[employeeId] = [];
			}
		} else {
			delete tempAccessObjects[employeeId]
			delete accessObjects[employeeId]
		}
		setSelectDepartmentError('');
		setTempAccessObject({ ...tempAccessObjects });
		setAccessObject({ ...accessObjects });
	}


	// METHOD TO ENTER TO SEARCH EMPLOYEE
	const enterToSearchMember = (e) => {
		if (e.charCode == 13) 
		{
			getEmployeeDetailsAPICall( categoryEnteredName );
		}
	}

	// METHOD TO ENTER TO SEARCH CATEGORY
	const searchCategoryByName = (e) => {
		if (e.charCode == 13) {
			getCategoryListAPICall(e.target.value.trim())
			setPagination({
				offset: 0,
				activePage: 1
			})
		}
	}

	// METHOD TO ENTER TO SEARCH STATUS
	const searchStatusForCategory = (e) => {
		if (e.charCode == 13) {
			getCategoryListAPICall(e.target.value)
			setPagination({
				offset: 0,
				activePage: 1
			})
		}
	}
	// METHOD TO SELECT SINGLE DEPARTMENT
	const selectSingleDepartment = (departmentId) => {
		let tempAccessObjects = tempAccessObject;

		if (tempAccessObjects[currentEmployeeId].includes(departmentId)) {
			tempAccessObjects[currentEmployeeId] = tempAccessObjects[currentEmployeeId].filter(id => id != departmentId);
		} else {
			tempAccessObjects[currentEmployeeId].push(departmentId);

		}
		setTempAccessObject({ ...tempAccessObjects });
	}

	// METHOD TO SELECT ALL CATEGORIES
	const selectAllDepartment = (e) => {

		let tempAccessObjects = tempAccessObject
		if (e.target.checked) {
			Object.keys(departmentList).map(departmentId => {
				if (!tempAccessObjects[currentEmployeeId].includes(departmentId)) {
					tempAccessObjects[currentEmployeeId].push(departmentId);
				}
			});
		} else {
			Object.keys(departmentList).map(departmentId => {
				tempAccessObjects[currentEmployeeId] = []
			});
		}

		setTempAccessObject({ ...tempAccessObjects });
	}

	// METHOD TO REMOVE SELECTED DEPARTMENTS
	const removeSelectedDepartment = (departmentId, faculty_id) => {
		let tempAccessObjects = tempAccessObject;
		let accessObjects = accessObject;

		accessObjects[faculty_id] = accessObjects[faculty_id].filter(id => id != departmentId);
		tempAccessObjects[faculty_id] = tempAccessObjects[faculty_id].filter(id => id != departmentId);

		setTempAccessObject({ ...tempAccessObjects });
		setAccessObject({ ...accessObjects });

	}

	// METHOD TO RETURN ADD CATEGORY SLIDER 
	const returnAddCategory = () => {
		return (
			<div id="addCategorySideMenu" style={{ display: categoryModal ? 'flex' : 'none' }}>
				<div id="addCategoryDataContainer">
					<div id="addCategoryHeader">
						<FontAwesomeIcon icon={['fas', 'times']} size="lg" onClick={() => closeAddCategory()} style={{ cursor: "pointer" }} />
						<h4 className="col-11">{categoryEditMode ? 'Update Category' : "Add Category"}</h4>
					</div>
					<div id="addCategoryBody">
						<div className='categoryName'>
							<label style={{ fontWeight: "bold", fontSize: 14 }}>Category Name <span style={{ color: 'red' }}>*</span></label>
							<input
								type="text"
								className='form-control addCategoryInput '
								placeholder='Enter Category Name'
								value={categoryName}
								onChange={(e) => getCategoryName(e)}
								style={{ fontSize: 14 }}
								maxLength='100'
							/>
							<div className='infoMessage'>Maximum 100 characters are allowed.</div>
							<p className='text-danger' style={{ fontSize: 12 }}>{categoryNameError}</p>
						</div>
						<div>
							<div className='categorySeries'>
								<label style={{ fontWeight: "bold", fontSize: 14 }}>Category Series <span style={{ color: 'red' }}>*</span></label>
								<input
									type="text"
									className='form-control addCategoryInput '
									placeholder='Enter Category Series'
									value={categorySeries}
									onChange={(e) => getCategorySeries(e)}
									style={{ fontSize: 14 }}
									maxLength='100'
								/>
								<div className='infoMessage'>Maximum 100 characters are allowed.</div>
								<p className='text-danger' style={{ fontSize: 12 }}>{categorySeriesError}</p>
							</div>
							<div className='cardFacultyTitle' style={{backgroundColor:"#FFF8DD"}} >
								<p> 
								   Note - Please note that once a series number is assigned to a Category, a Notice ID will be automatically generated. 
								</p>
								<p> Example : <b>Category Series - Exam and Notice ID - Exam - 01</b> </p>
							</div>

						</div>
						<div className='categoryDescription' style={{ marginTop: 10 }}>
							<label style={{ fontWeight: "bold", fontSize: 14 }}>Category Description <span style={{ color: 'red' }}>*</span></label>
							<input
								type="text"
								className='form-control addCategoryInput '
								placeholder='Enter Description'
								value={categoryDescription}
								onChange={(e) => getCategoryDescription(e)}
								style={{ fontSize: 14 }}
								maxLength='500'
							/>
							<div className='infoMessage'>Maximum 500 characters are allowed.</div>
							<p className='text-danger' style={{ fontSize: 12 }}>{categoryDescriptionError}</p>
						</div>
						<div className='categoryStatus' style={{ marginTop: 10 }}>
							<label style={{ fontWeight: "bold", fontSize: 14 }}>Status</label>
							<select
								className="form-control addCategoryInput "
								aria-label="Default select example"
								value={status}
								onChange={(e) => getCategoryStatus(e)}

							>
								<option value="Active">Active</option>
								<option value="Inactive">Inactive</option>
							</select>
						</div>
					</div>
					<div id="addCategoryFooter" className="col-md-12" style={{ marginBottom: 10 }}>
						<button className="btn primary-button" onClick={() => validateAddCategory()} >{categoryEditMode ? 'Update Category' : "Add Category"}</button>
						<button className="btn outline-button" onClick={() => closeAddCategory()}>Cancel</button>
					</div>
				</div>
			</div >
		);
	}

	// METHOD TO APPLY FILTER
	const applyFilter = () => {
		setPagination({
			offset: 0,
			limit: pagination.limit,
			activePage: 1
		});
	}

	// METHOD TO DELETE CATEGORY MODAL
	const getDeleteCategoryDetails = () => {
		setDeleteModalDetails({
			deleteModal: true,
		})
	}

	// METHOD FOR CLOSE DELETE MODAL
	const closeDeleteModal = () => {
		setDeleteModalDetails({
			DeleteModal: false,
			deleteModalText: '',
			deleteErrorVisibility: false,
		})
	}

	// METHOD TO CLOSE FILTER CATEGORY MODAL
	const closeFilterCategory = () => {
		setFilterTitle('');
		setFilterStatus('');
		setPagination({
			offset: 0,
			limit: 10,
			activePage: 1
		});
		getCategoryListAPICall();

	}

	// METHOD TO CLOSE ADD CATEGORY MODAL
	const closeAddCategory = () => {
		setCategoryModal(false);
		setCategoryNameError(false);
		setCategorySeries("");
		setCategoryDescriptionError(false);
		setCategoryName('');
		setCategoryDescription('');
		setStatus('Active');
		setCategoryIds([]);
	}

	// METHOD TO GET UPDATE CATEGORY DETAILS
	const getUpdateCategoryDetails = () => {
		if (selectedCategoryIds.length > 1) {
			setSuccessModalDetails({
				successModal: true,
				successModalType: 'warning',
				successMessage: 'Please select only one category to update.'
			})
		} else {
			let category = categoryList[selectedCategoryIds.toString()];
			setCategoryModal(true);
			setCategoryEditMode(true);
			setCategoryName(category.title);
			setCategoryUniqueId(category.categoryId);
			setCategoryDescription(category.description);
			setCategorySeries(category.series)
			setStatus(category.status == '' ? 'Active' : category.status);
		}
	}

	// METHOD TO GET CATEGORY NAME
	const getCategoryName = (e) => {
		if (e.target.value.trim() == '') {
			setCategoryName(e.target.value);
			setCategoryNameError("Category name cannot be empty.");
		} else {
			setCategoryName(e.target.value);
			setCategoryNameError("");
		}
	}

	// METHOD TO GET CATEGORY NAME
	const getCategorySeries = (e) => {
		if (e.target.value.trim() == '') 
		{
			setCategorySeries(e.target.value);
			setCategorySeriesError("Category series cannot be empty.");
		} 
		else {
			setCategorySeries(e.target.value);
			setCategorySeriesError("");
		}
	}

	// METHOD TO GET CATEGORY DESCRIPTION
	const getCategoryDescription = (e) => {
		if (e.target.value.trim() == '') {
			setCategoryDescription(e.target.value);
			setCategoryDescriptionError("Category description cannot be empty.");
		} else {
			setCategoryDescription(e.target.value);
			setCategoryDescriptionError("");
		}
	}

	// METHOD TO GET STATUS
	const getCategoryStatus = (e) => {
		setStatus(e.target.value);
	}

	// METHOD FOR ADD CATEGORY VALIDATION
	const validateAddCategory = () => {
		let isValid = true;
		if (categoryName.trim() == "") 
		{
			isValid = false
			setCategoryNameError('Category name cannot be empty.');
		}
		if (categorySeries.trim() == "") 
		{
			isValid = false
			setCategorySeriesError('Category series cannot be empty.');
		}
		if (categoryDescription.trim() == "") {
			isValid = false
			setCategoryDescriptionError('Category description cannot be empty.');
		}

		if (isValid) {
			if (categoryEditMode) {
				editCategoryAPICall();
				setCategoryModal(false);
				setCategoryEditMode(false);
			} else {
				addCategoryAPICall();

			}
		}
	}

	// METHOD FOR ADD CATEGORY API CALL
	const addCategoryAPICall = async () => {
		let formData = {
			"iid": config.institute_id,
			"title": categoryName,
			"series" : categorySeries,
			"description": categoryDescription,
			"status": status,
			"addedby": config.faculty_id,
			"academicYear": config.instructorInfo.AcaYearId
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'AddNoticeBoardCategory',
			formData,
			apiPath
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				addCategoryAPICall();
			}, 1000);
		} else {
			if (jsonResponse.APIResult.success) {
				if (jsonResponse.APIResult.status == "success") 
				{
					let categoryUniqueId = jsonResponse.APIResult.UID;
					let categoryData = categoryList;
					let categorySequenceArray = categorySequence;
					// if (pagination.activePage == 1) 
					// {
					// 	categorySequenceArray.pop();
					// 	categorySequenceArray.unshift(categoryUniqueId);
					// 	categoryData[categoryUniqueId] = ({
					// 		"categoryId": categoryUniqueId,
					// 		"title": categoryName,
					// 		"series" : categorySeries,
					// 		"description": categoryDescription,
					// 		"status": status
					// 	});
					// } else {
					// }
					setCategoryList(categoryData);
					setCategoryModal(false);
					setCategoryModal(false);
					setCategoryNameError(false);
					setCategoryDescriptionError(false);
					setCategoryName('');
					setCategorySeries("");
					setCategoryDescription('');
					setStatus('Active');
					setSuccessModalDetails({
						successModal: true,
						successModalType: "success",
						successMessage: jsonResponse.APIResult.message
					});
					getCategoryListAPICall();
				} else {
					setCategoryModal(true);
					setCategoryNameError(false);
					setCategoryDescriptionError(false);
					setCategoryName('');
					setCategorySeries("");
					setCategoryDescription('');
					setCategorySeries("")
					setStatus('Active');
					setSuccessModalDetails({
						successModal: true,
						successModalType: "warning",
						successMessage: jsonResponse.APIResult.message
					});
				}
			} else {
				setCategoryModal(true);
				setSuccessModalDetails({
					successModal: true,
					successModalType: "error",
					successMessage: jsonResponse.APIResult.message
				});
			}
		}
	}

	// METHOD TO EDIT CATEGORY API CALL
	const editCategoryAPICall = async () => {
		let formData = {
			"iid": config.institute_id,
			"uid": categoryUniqueId,
			"title": categoryName,
			"series" : categorySeries,
			"description": categoryDescription,
			"status": status,
			"last_updated_by": config.faculty_id,
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'UpdateNoticeBoardCategory',
			formData,
			apiPath
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				editCategoryAPICall();
			}, 1000);

		} else {
			if (jsonResponse.APIResult.success) {
				if (jsonResponse.APIResult.status == "success") {
					let selectedCategoryId = selectedCategoryIds;
					selectedCategoryId = [];
					setCategoryIds([...selectedCategoryId]);
					let categoryListData = categoryList;
					categoryListData[categoryUniqueId].title = categoryName;
					categoryListData[categoryUniqueId].description = categoryDescription;
					categoryListData[categoryUniqueId].status = status;
					setCategoryList(categoryListData);
					setCategoryModal(false);
					setCategoryEditMode(false);
					setCategoryNameError(false);
					setCategoryDescriptionError(false);
					setCategoryName('');
					setCategoryDescription('');
					setCategorySeries("")
					setStatus('Active');
					setSuccessModalDetails({
						successModal: true,
						successModalType: "success",
						successMessage: jsonResponse.APIResult.message
					});
					getCategoryListAPICall()
				} else {
					setCategoryModal(false);
					setCategoryModal(false);
					setCategoryNameError(false);
					setCategoryDescriptionError(false);
					setCategoryName('');
					setCategoryDescription('');
					setCategorySeries("")
					setStatus('Active');
					setSuccessModalDetails({
						successModal: true,
						successModalType: "warning",
						successMessage: jsonResponse.APIResult.message
					});
				}
			} else {
				setSuccessModalDetails({
					successModal: true,
					successModalType: "error",
					successMessage: "Something went wrong while getting category list. Please try again later."
				});
			}
		}
	}

	// METHOD TO DELETE CATEGORY API CALL
	const deleteCategoryApiCall = async () => {
		let formData = {
			"iid": config.institute_id,
			"categoryIdArray": selectedCategoryIds,
			"added_by": config.faculty_id,

		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'DeleteNoticeBoardCategory',
			formData,
			apiPath
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				deleteCategoryApiCall();
			}, 1000);

		} else {
			if (jsonResponse.success) {
				if (jsonResponse.APIResult.status == "success") {
					let deletedCategoryIdArray = jsonResponse.APIResult.deletedCategoryIdArray
					let categorySequenceTemp = categorySequence.map(item => item);

					deletedCategoryIdArray.map((categoryId) => {
						categorySequenceTemp = categorySequenceTemp.filter(id => id != categoryId);
						if (categoryList[categoryId] != undefined) {
							delete categoryList[categoryId];
						}
					})

					setCategorySequence(categorySequenceTemp);
					setCategoryIds([]);
					setDeleteModalDetails({
						DeleteModal: false,
					});
					setSuccessModalDetails({
						successModal: true,
						successModalType: "success",
						successMessage: jsonResponse.APIResult.message
					});
				} else {
					setDeleteModalDetails({
						DeleteModal: false,
					});
					setSuccessModalDetails({
						successModal: true,
						successModalType: "warning",
						successMessage: jsonResponse.APIResult.message
					});
				}
			} else {
				setDeleteModalDetails({
					DeleteModal: false,
				});
				setSuccessModalDetails({
					successModal: true,
					successModalType: "error",
					successMessage: 'Something went wrong while deleting category. Please try again later.'
				});
			}
		}
	}

	// METHOD TO REMOVE USER CATEGORY ACCESS 
	const getRemoveCategoryAccess = async (selectedId, categoryId, sid, accessType) => {

		let formData = {
			"institute_id": config.institute_id,
			"user_id_array": [selectedId],
			"category_id": categoryId,
			"sid": sid,
			"access_type": accessType,
			"added_by" : config.faculty_id,
		}

		let jsonResponse = await NoticeboardAPICall.makeApiCall(
			'removeUserCategoryAccess',
			formData,
			apiPath
		);

		if (jsonResponse.expired) {
			setTimeout(() => {
				getRemoveCategoryAccess(selectedId, categoryId, sid, accessType);
			}, 1000);
		} else {
			if (jsonResponse.success) {
				if (jsonResponse.APIResult.status == "success") {
					let selectedUserIds = selectedUserId;

					selectedUserIds = [];
					setUserId([...selectedUserIds]);
					getCategoryListAPICall();
					setSuccessModalDetails({
						successModal: true,
						successModalType: "success",
						successMessage: jsonResponse.APIResult.message
					});
				}

			} else {
			}
		}
	}

	// METHOD TO CLOSE SUCCESS MODAL
	const closeSuccessModal = () => {
		setSuccessModalDetails({
			successModal: false,
			successModalType: "",
			successMessage: ""
		});
	}

	// METHOD FOR CATEGORY PAGINATION COUNT
	const updatePaginationCount = (pageNumber) => {
		setPagination({
			offset: (pageNumber - 1) * pagination.limit,
			limit: pagination.limit,
			activePage: pageNumber,
		});
		setCategoryIds([]);
	}

	// METHOD TO MEMBER PAGINATION COUNT
	const updateMemberPaginationCount = (pageNumber) => {
		setMemberPagination({
			offset: (pageNumber - 1) * memberPagination.limit,
			limit: memberPagination.limit,
			activePage: pageNumber,
		});

	}
	// METHOD FOR SET SHOW RESULT
	const setShowResult = (e) => {
		setPagination({
			offset: 0,
			limit: e.target.value,
			activePage: 1
		});
	}

	// METHOD FOR GET ASSIGN ACCESS
	const getAssignAccess = () => {
		if (selectedCategoryIds.length > 1) {
			setSuccessModalDetails({
				successModal: true,
				successModalType: 'warning',
				successMessage: "Please select only one category to assign access."
			})
		} else {
			setAssignAccess(true);
		}
	}

	// METHOD TO CLOSE ASSIGN ACCESS
	const closeAssignAccess = () => {
		setAssignAccess(false);
		setTempAccessObject({});
		setAccessObject({})
		setCategoryIds([]);
		setSelectDepartmentError('');
		setUserErrorMessage('');
		setCategoryEnteredName("");
	}

	// METHOD TO CLOSE ASSIGN ACCESS
	const switchAssignAccess = (type) => {
		setTempAccessObject({});
		setAccessObject({});
		setSelectDepartmentError('');
		setUserErrorMessage('');
		setSelectedAccessType(type);
	}

	// METHOD TO RETURN DEPARTMENT MODAL
	const getSelectDepartmentModal = (faculty_id) => {
		setSelectDepartment(true);
		setCurrentEmployeeId(faculty_id);
		setSelectDepartmentError('');
	}

	// METHOD TO RETURN ASSIGN ACCESS MODAL
	const returnAssignAccessModal = () => {
		return (
			<div id="addAssignAccessMenu" style={{ display: AssignAccess ? 'flex' : 'none' }}>
				<div id="addAssignAccessDataContainer">
					<div id="addAssignAccessHeader">
						<FontAwesomeIcon icon={['fas', 'times']} size="lg"
							onClick={() => closeAssignAccess()}
							style={{ cursor: "pointer" }} />
						<h4 className="col-11">Assign Access</h4>
					</div>
					<div className='row col-md-12'>
						<div className='col-md-12' style={{ padding: 0 }}>
							<ul className='nav'>
								<li className={selectedAccessType == "postNoticeAccess" ? "tab selectedtab" : "tab"} onClick={() => { switchAssignAccess('postNoticeAccess') ; setCategoryEnteredName("");getEmployeeDetailsAPICall("") }}>
									<a className='nav-link '>Post Notice Access</a>
								</li>
								<li className={selectedAccessType == "noticeApprover" ? "tab selectedtab" : "tab"} onClick={() => {switchAssignAccess('noticeApprover') ; setCategoryEnteredName("");getEmployeeDetailsAPICall("") }}>
									<a className='nav-link'>Notice Approver</a>
								</li>
							</ul>
						</div>
					</div>
					<div id="addAssignAccessBody">
						<p className='secondaryColor' style={{ fontSize: 14 }}>Note : Select the user(s) and department(s) to assign to the select category. Only that user(s) will be able to post notice for that category and for the selected department(s).</p>
						<label>Select Member<span style={{ color: 'red', marginLeft: 1 }}> *</span></label>
						<input
							type="text"
							className='form-control addAssignAccessInput'
							placeholder='Type & press enter to search by name or erp id'
							onChange={(e)=>{ setCategoryEnteredName(e.target.value) }}
							onKeyPress={(e) => enterToSearchMember(e)}
							style={{ fontSize: 14 }}
							value = { categoryEnteredName }
						/>
						<p
							onClick={e => getEmployeeDetailsAPICall('')}
							style={{
								fontSize: 12,
								textDecoration: 'underline',
								cursor: 'pointer',
								textAlign: "right"
							}}
						> Clear search</p>
						<div className='row '>
							<div className='col employees '>
								{
									employeeFetching ?
										<div className='d-flex'>
											<div colSpan={8} style={{ padding: 5 }}>
												<ButtonLoader />
											</div>
										</div>
										:
										Object.values(employeeList).length > 0 ?
											Object.values(employeeList).map((employee, employeeIndex) => {

												return (
													<div key={employee.faculty_id} className='row my-1' >
														<div className='col-7 d-flex' style={{ padding: 0 }}>
															<input
																type="checkbox"
																checked={accessObject[employee.faculty_id] != undefined}
																onChange={(e) => selectSingleEmployee(e, employee.faculty_id)}
																style={{ marginRight: 3, paddingLeft: 0 }}
															/>

															<div className='employeeNames'>{employee.faculty_fname}  {employee.faculty_lname} {employee.faculty_user_id.length > 0 && 	'|' }  {employee.faculty_user_id} </div>

														</div>

														{
															selectedAccessType == "postNoticeAccess" &&
															<div className='col-5'>
																{
																	accessObject[employee.faculty_id] != undefined &&
																	<input
																		type="text"
																		className='form-control SelectDepartmentInput'
																		placeholder='Click here to select department'
																		onClick={() => getSelectDepartmentModal(employee.faculty_id)}
																		style={{ fontSize: 14, marginBottom: 10 }}
																	/>
																}
																{
																	(accessObject[employee.faculty_id] != undefined && accessObject[employee.faculty_id].length > 0) &&
																	accessObject[employee.faculty_id].map(departmentId => {
																		return (
																			<div key={departmentId}>
																				<p style={{ fontSize: 14 }}>{departmentList[departmentId].stream_name}<Close style={{ cursor: 'pointer', fontSize: 'sm' }} onClick={() => removeSelectedDepartment(departmentId, employee.faculty_id)} /></p>
																			</div>
																		);
																	})
																}
															</div>
														}

													</div>
												);
											})
											:
											<div >
												<div colSpan={8} style={{ padding: 5 }}>
													No employee found as per search.
												</div>
											</div>
								}

								<div >
									{
										Object.keys(employeeList).length > 0 &&
										<div className="paginationContainer1">
											<Pagination
												activePage={memberPagination.activePage}
												itemsCountPerPage={memberPagination.limit}
												totalItemsCount={totalRecord}
												pageRangeDisplayed={3}
												onChange={(num) => updateMemberPaginationCount(num)}
											/>
										</div>
									}
								</div>

							</div>
						</div>


					</div>
					<div style={{ textAlign: 'left', padding: 5 }}>
						<p style={{ fontSize: 14, color: "red", marginTop: 10 }}>{grantAccessWarning}</p>
						<p style={{ fontSize: 14, color: "red", marginTop: 10 }}>{selectDepartmentError}</p>
					</div>
					<div className=' addAssignAccessFooter'>
						<div style={{ marginBottom: 10 }}>
							<button className="btn primary-button" onClick={() => getCategoryGrantAccess()} >Grant Access</button>
							<button className="btn outline-button" onClick={() => closeAssignAccess()}>Cancel</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	// METHOD TO RETURN DEPARTMENT MODAL
	const returnDepartmentModal = () => {
		return (
			<>
				<div className={selectDepartment ? 'modal fade show' : 'modal fade'} id="exampleModal" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
					<div className="modal-dialog  " >
						<div className="modal-content selectDepartmentModal" >
							<div className="modal-header selectDepartment-header">
								<h4 className="col-11" >Select Department</h4>
								<FontAwesomeIcon icon={['fas', 'times']} size="lg" style={{ cursor: "pointer" }} onClick={() => closeSelectDepartmentModal()} ></FontAwesomeIcon>
							</div>
							<div className="modal-body"  >
								<div className='d-flex'>
									<input
										type="checkbox"
										checked={(tempAccessObject[currentEmployeeId] !== undefined && tempAccessObject[currentEmployeeId].length > 0) && Object.keys(departmentList).length == Object.values(tempAccessObject[currentEmployeeId]).length}
										onChange={(e) => selectAllDepartment(e)}
										style={{ marginRight: 5 }}
									/>
									<div style={{ fontSize: 14 }}>Select All</div>
								</div>
								{
									Object.values(departmentList).length > 0 ?
										Object.values(departmentList).map((department, departmentsIndex) => {
											return (
												<div className='d-flex' style={{ padding: 0 }} key={department.departmentId}>
													<div>
														<input
															type="checkbox"
															checked={tempAccessObject[currentEmployeeId] != undefined && tempAccessObject[currentEmployeeId].includes(department.departmentId)}
															// checked={Object.values(selectedDepartmentIds).includes(department.departmentId)? true :false}
															onChange={() => selectSingleDepartment(department.departmentId)}
															style={{ marginRight: 5 }}
														/>
													</div>
													<div style={{ fontSize: 14 }}>{department.stream_name}</div>
												</div>
											)
										})
										:
										<tr>
											<td colSpan={8} style={{ padding: 5 }}>
												No employee added yet.
											</td>
										</tr>
								}

							</div>
							<div className="modalButton">
								<button className="btn primary-button" onClick={() => confirmDepartmentSelection()}>Continue</button>
							</div>
						</div>
					</div>
				</div>

			</>
		)
	}

	// METHOD TO CONFIRM DEPARTMENT SELECTION FOR EMPLOYEES
	const confirmDepartmentSelection = () => {
		// let accessObjects = accessObject;
		// let selectedStream = tempAccessObject[currentEmployeeId];
		// accessObjects[currentEmployeeId] = selectedStream;
		// setAccessObject({ ...accessObjects });
		let accessObjectDetails = {};
		if (Object.keys(tempAccessObject).length > 0) {
			Object.keys(tempAccessObject).map(userId => {
				if (accessObjectDetails[userId] == undefined) {
					accessObjectDetails[userId] = [];
				}

				accessObjectDetails[userId] = tempAccessObject[userId];
			});
		}
		setAccessObject({ ...accessObjectDetails });
		setSelectDepartment(false);
	}

	// METHOD FOR CLOSE ASSIGN ACCESS MODAL
	const closeSelectDepartmentModal = () => {
		setSelectDepartment(false);
	}

	// METHOD TO GET CATEGORY GRANT ACCESS
	const getCategoryGrantAccess = () => {
		let validData = true;
		if (Object.keys(accessObject).length == 0) 
		{
			setUserErrorMessage('Please select member to which you want to assign access.');
			validData = false;
		}
		if (Object.keys(accessObject).length > 0 && selectedAccessType == "postNoticeAccess" ) 
		{
			Object.keys(accessObject).map(memberId => {
				if (accessObject[memberId].length < 1) 
				{
					setSelectDepartmentError('Please select department for selected member.');
					validData = false;
				}
			});
		}

		if (validData) {
			apiCallToAssignAccess();
			getCategoryListAPICall();
			setTempAccessObject({});
			setAccessObject({});
			setCategoryIds([]);

		}
	}

	// METHOD TO GET RETURN MANAGE CATEGORY
	return (
		<>
			<div
				className=" d-flex flex-wrap "
				style={{
					backgroundColor: "#f2f2f2",
					marginTop: 10,
					padding: '8px 15px',
					position: 'sticky',
					top: '10%',
					zIndex: 1,
				}}
			>
				<div className='icons flex-grow-1'>
					<div className='selectFilterCategory'>
						<input
							type="text"
							className='form-control addCategoryInput'
							placeholder='Enter Category Name'
							value={filterTitle}
							onChange={(e) => setFilterTitle(e.target.value)}
							onKeyPress={(e) => searchCategoryByName(e)}
							style={{ fontSize: 14 }}
						/>
					</div>
					<div className="selectFilterStatus">
						<select
							className="form-control addCategoryInput"
							aria-label="Default select example"
							value={filterStatus}
							onChange={(e) => setFilterStatus(e.target.value)}
							onKeyPress={(e) => searchStatusForCategory(e)}
							style={{ fontSize: 14 }}
						>
							<option value="">Select Status</option>
							<option value="Active">Active</option>
							<option value="Inactive">Inactive</option>
						</select>
					</div>
					<div className='filterButtons pl-4'>
						<div>
							<button className="btn btn-primary button" onClick={() => applyFilter()} >Apply</button>
						</div>
						<div >
							<button className="button btn btn-outline-primary" onClick={() => closeFilterCategory()} >Clear</button>
						</div>
					</div>
				</div>
				<div className='addCategories'>
					<div className='showResult'>Show Results
					</div>
					<select
						className="form-select"
						aria-label="Default select example"
						value={pagination.limit}
						onChange={(e) => setShowResult(e)}
						style={{ fontSize: 12, marginRight: 10 }}
					>
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="40">40</option>
						<option value="100">100</option>
						<option value="250">250</option>
					</select>
					&nbsp;&nbsp;
					<div
						className='mr-2'
						style={{ fontSize: 'smaller' }}
					>
						Total records: {categoryCount}
					</div>
					<div>
						<button type="button" className="btn btn-primary btn-lg button" onClick={() => { setCategoryModal(true) }} >
							<FontAwesomeIcon icon={["fas", "plus"]} style={{ marginRight: 3 }} />
							Add Category
						</button>
					</div>
				</div>
			</div>
			<div className='table-responsive col-md-12 '>
				<table className='table table-bordered'>
					<thead
						style={{
							position: 'sticky',
							top: '0',
							backgroundColor: '#fff',
						}}
					>
						<tr >
							<th style={{ padding: 5 }}>
								<input
									type="checkbox"
									checked={Object.keys(categoryList).length > 0 && Object.keys(categoryList).length == selectedCategoryIds.length}
									onChange={(e) => selectAllCategories(e)}
								/>
							</th>
							<th style={{ padding: 5 }}>Sr. No.</th>
							<th style={{ padding: 5 }}>Category Name</th>
							<th style={{ padding: 5 }}>Series</th>
							<th style={{ padding: 5 }}>Category Description</th>
							<th style={{ padding: 5 }}>Approvers</th>
							<th style={{ padding: 5 }}>Department</th>
							<th style={{ padding: 5 }}>Responsible</th>
							<th style={{ padding: 5 }}>Notices</th>
							<th style={{ padding: 5 }}>Status</th>
						</tr>
						{
							selectedCategoryIds.length > 0 &&
							<tr className="active-row " style={{ backgroundColor: "#fed7660d" }}>
								<td colSpan="8" className="componentAction-button">
									<div style={{ padding: 5 }} >
										<span style={{ border: "1px solid black", padding: "5px", borderRadius: "20px", marginRight: "10px", cursor: "pointer" }} onClick={() => getAssignAccess()} >
											Assign Access
										</span>
										<span style={{ border: "1px solid black", padding: "5px", borderRadius: "20px", marginRight: "10px", cursor: "pointer" }} onClick={() => getUpdateCategoryDetails()} >
											Update
										</span>
										<span style={{ border: "1px solid black", padding: "5px", borderRadius: "30px", cursor: "pointer" }} onClick={() => getDeleteCategoryDetails()} >
											Delete
										</span>
									</div>
								</td>
							</tr>
						}
					</thead>
					<tbody>
						{
							categoryFetching ?
								<tr>
									<td colSpan={10} style={{ padding: 5 }}>
										<ButtonLoader />
									</td>
								</tr>
								:
								Object.keys(categoryList).length > 0 && categorySequence ?
									categorySequence.map((categoryId, categoryIndex) => {
										let category = categoryList[categoryId];
										if(category && category.accessObject)
										{
											return (
												<>
													<tr key={category.categoryId} style={{ borderLeft: category?.status == 'Active' ? '3px solid #70EB24' : '3px solid  #A4A4A4' }}>
														<td style={{ padding: 5 }} rowSpan={category?.accessObject != undefined && Object.keys(category.accessObject)?.length > 0 ? Object.keys(category.accessObject)?.length : 1}>
															<input
																type="checkbox"
																checked={selectedCategoryIds.includes(category.categoryId)}
																onChange={() => selectSingleCategory(category.categoryId)}
															/>
														</td>
														<td style={{ padding: 5 }} rowSpan={category.accessObject != undefined && Object.keys(category.accessObject)?.length > 0 ? Object.keys(category.accessObject)?.length : 1}>{pagination.offset + categoryIndex + 1}</td>
														<td style={{ padding: 5 }} rowSpan={category.accessObject != undefined && Object.keys(category.accessObject)?.length > 0 ? Object.keys(category.accessObject)?.length : 1} title={category.title}>
															<p style={{ width: 300, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{category.title}</p>
														</td>
														<td style={{ padding: 5 }} rowSpan={category.accessObject != undefined && Object.keys(category.accessObject)?.length > 0 ? Object.keys(category.accessObject)?.length : 1} title={category.series}>{category.series?.length > 50 ? category.series.substring(0, 50) + "..." : category.series}</td>
														<td style={{ padding: 5 }} rowSpan={category.accessObject != undefined && Object.keys(category.accessObject)?.length > 0 ? Object.keys(category.accessObject)?.length : 1} title={category.description}>{category.description?.length > 50 ? category.description.substring(0, 50) + "..." : category.description}</td>
														<td style={{ padding: 5 }} rowSpan={category.accessObject != undefined && Object.keys(category.accessObject)?.length > 0 ? Object.keys(category.accessObject)?.length : 1}>
														{
															(category.approverObject != undefined && Object.keys(category.approverObject).length > 0) &&
															Object.values(category.approverObject).map((stream, streamIndex) => {
																return (
																		
																			(stream.approverNameObject != undefined && Object.keys(stream.approverNameObject).length > 0) &&
																			Object.keys(stream.approverNameObject).map(facultyId => {
																				return (
																					<div className='facultyName'>
																						{
																							stream.approverNameObject[facultyId]
																						}
																						<FontAwesomeIcon icon={['fas', 'times']} color='#eb5757' style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => removeSingleUser(facultyId, category.categoryId, stream.sid, 'noticeApprover')} />
																					</div>
																				)
																			})
																		
																		)
																	})
														}
														</td>
														{
															(category.accessObject && Object.keys(category.accessObject).length > 0) ?
																Object.values(category.accessObject).map((stream, streamIndex) => {
																	if (streamIndex == 0) {
																		return (
																			<>
																				<td className={!stream.sidName && 'notFoundMessage'} style={{ padding: 5 }}>{stream.sidName ? stream.sidName : 'Not defined'}</td>
																				<td style={{ padding: 5 }}>
																					{
																					  stream.facultyNameObject && Object.keys(stream.facultyNameObject).length > 0 &&
																						Object.keys(stream.facultyNameObject).map(facultyId => {
																							return (
																								<div className='facultyName'>
																									{
																										stream.facultyNameObject[facultyId]
																									}
																									<FontAwesomeIcon icon={['fas', 'times']} color='#eb5757' style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => removeSingleUser(facultyId, category.categoryId, stream.sid, 'postNoticeAccess')} />
																								</div>
																							)
																						})
																					}
																				</td>
	
																			</>
																		);
																	}
																})
																:
																<>
																
																	<td style={{ padding: 5 }}></td>
																	<td style={{ padding: 5 }}></td>
																</>
														}
														<td style={{ padding: 5 }} rowSpan={category.accessObject != undefined && Object.keys(category.accessObject).length > 0 ? Object.keys(category.accessObject).length : 1}>{category.noticecount}</td>
														<td rowSpan={category.accessObject != undefined && Object.keys(category.accessObject).length > 0 ? Object.keys(category.accessObject).length : 1} style={{ color: category.status == "Active" ? '	#70EB24' : '#A4A4A4', fontWeight: "bold", padding: 5 }} >{category.status}</td>
													</tr>
	
													{
														(category.accessObject != undefined && Object.keys(category.accessObject).length > 0) &&
														Object.values(category.accessObject).map((stream, streamIndex) => {
															if (streamIndex > 0) {
																return (
																	<tr style={{ borderLeft: category.status == 'Active' ? '3px solid #70EB24' : '3px solid  #A4A4A4' }}>
																		{/* {
																			(category.approverObject != undefined && Object.keys(category.approverObject).length > 0) &&
																			Object.values(category.approverObject).map((stream, streamIndex) => {
																				return (
																					<td style={{ padding: 5 }}>
																						{
																							(stream.approverNameObject != undefined && Object.keys(stream.approverNameObject).length > 0) &&
																							Object.keys(stream.approverNameObject).map(facultyId => {
																								return (
																									<div className='facultyName'>
																										{
																											stream.approverNameObject[facultyId]
																										}
																										<FontAwesomeIcon icon={['fas', 'times']} color='#eb5757' style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => removeSingleUser(facultyId, category.categoryId, stream.sid, 'noticeApprover')} />
																									</div>
																								)
																							})
																						}
																					</td>
																				)
																			})
																		} */}
																	
																		<td className={!stream.sidName && 'notFoundMessage'} style={{ padding: 5 }}>{stream.sidName ? stream.sidName : 'Not defined'}</td>
																		<td style={{ padding: 5 }}>
																			{
																				Object.keys(stream.facultyNameObject).length > 0 &&
																				Object.keys(stream.facultyNameObject).map(facultyId => {
																					return (
																						<div className='facultyName'>
																							{
																								stream.facultyNameObject[facultyId]
																							}
																							<FontAwesomeIcon icon={['fas', 'times']} color='#eb5757' style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => removeSingleUser(facultyId, category.categoryId, stream.sid)} />
																						</div>
																					)
																				})
																			}
																		</td>
	
																	</tr>
																);
															}
														})
													}
												</>
											);
										}
										
									})
									:
									<tr>
										<td colSpan={10} style={{ padding: 5 }}>
											No category added yet. Please click on 'Add Category' to add the category.
										</td>
									</tr>
						}
					</tbody>
				</table>
			</div>
			<div className='mb-5'>
				{
					Object.keys(categoryList).length > 0 &&
					<div className="paginationContainer">
						<Pagination
							activePage={pagination.activePage}
							itemsCountPerPage={pagination.limit}
							totalItemsCount={categoryCount}
							pageRangeDisplayed={3}
							onChange={(num) => updatePaginationCount(num)}
						/>
					</div>
				}
			</div>
			{/* PAGINATION FOR MANAGE CATEGORY LIST . */}
			{/* METHOD FOR RETURN ADD CATEGORY MODAL. */}
			{
				returnAddCategory()
			}
			{/* METHOD FOR RETURN ASSIGN ACCESS MODAL */}
			{
				returnAssignAccessModal()
			}
			{/* METHOD FOR RETURN DEPARTMENT MODAL */}
			{
				returnDepartmentModal()
			}
			{/* SUCCESS MODAL FOR MANAGE CATEGORY */}
			{
				successModalDetails.successModal &&
				<SuccessModal
					successModal={successModalDetails.successModal}
					successModalType={successModalDetails.successModalType}
					successMessage={successModalDetails.successMessage}
					closeSuccessModal={closeSuccessModal}
				/>
			}
			{/* DELETE MODAL FOR MANAGE CATEGORY */}
			{
				deleteModalDetails.deleteModal &&
				<DeleteModal
					showModal={deleteModalDetails.deleteModal}
					visibility={closeDeleteModal}
					deleteKey="Category"
					getMessage={deleteModalDetails.getMessage}
					deleteComponent={deleteCategoryApiCall}
				/>
			}
		</>
	);
}

export default CategoryList;